import { Bloom } from "./loader/index.js";
import "./wordmark.css";

/**
 * The product's name as a mark: the Crux mark beside "Crux" (DESIGN.md §3, "The mark").
 *
 * The rail, the sign-in page and setup each open with it, and a customer who
 * arrives from the EMIAC site has just seen this mark there. The mark is its own
 * file, which the API serves to a signed-out browser, and its alt text is empty:
 * the name beside it is what a screen reader should hear.
 *
 * `introTarget` makes it where the app intro lands (`IntroProvider`). `busy`
 * assembles the mark while a page's data is first loading — drawn from the
 * same petals, so it is the file's mark moving, not a second drawing of it.
 */
export function Wordmark({
  className,
  introTarget = false,
  busy = false,
}: {
  readonly className: string;
  readonly introTarget?: boolean;
  readonly busy?: boolean;
}) {
  return (
    <span className={`wordmark ${className}`}>
      {busy ? (
        <span
          className="wordmark-mark"
          {...(introTarget ? { "data-intro-target": "" } : {})}
        >
          <Bloom size={24} motion="assemble" className="wordmark-bloom" />
        </span>
      ) : (
        <img
          className="wordmark-mark"
          src="/crux-mark.svg"
          alt=""
          width={24}
          height={24}
          {...(introTarget ? { "data-intro-target": "" } : {})}
        />
      )}
      <span className="wordmark-name">Crux</span>
    </span>
  );
}
